import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { map, take, switchMap, of, catchError } from 'rxjs';

export const authGuard = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.isAuthenticated$.pipe(
        take(1),
        switchMap(isAuthenticated => {
            if (!isAuthenticated) {
                router.navigate(['/login']);
                return of(false);
            }

            // If authenticated, ensure user data is loaded
            return authService.currentUser$.pipe(
                take(1),
                switchMap(user => {
                    if (!user) {
                        // User data not loaded yet, fetch it
                        return authService.fetchCurrentUser().pipe(
                            map(() => true),
                            catchError(() => {
                                // If fetching user fails, logout
                                authService.logout();
                                return of(false);
                            })
                        );
                    }
                    return of(true);
                })
            );
        })
    );
};
